import { useEffect, useState } from 'react'

import { focusManager } from '@fv/client-core'

export function useAppFocus() {
  const [isFocused, setFocused] = useState(focusManager.isFocused())

  useEffect(() => {
    focusManager.subscribe(() => {
      setFocused(focusManager.isFocused())
    })
  }, [])

  return isFocused
}
